export default __webpack_public_path__ + "static/media/a7.0b96aa35.JPG";